module.exports = __webpack_public_path__ + "static/media/cancel-trip.be0248cb.svg";